import { titleize } from "helpers/string";

function confirmRemoveMeetingArgs() {
  return {
    header: "Confirm Remove Meeting",
    subHeader: "Heads up! This can't be undone.",
    body: "Are you sure you want to remove this meeting? It will delete the calendar invite as well",
    confirmButtonText: "Yes, remove",
  };
}

export function confirmRemoveArgs(resourceType: "email" | "message" | "task" | "meeting" | "checkpoint") {
  if (resourceType === "meeting") {
    return confirmRemoveMeetingArgs();
  }
  return {
    header: "Confirm Delete",
    subHeader: "Heads up! This can't be undone.",
    body: `Are you sure you want to delete this ${titleize(resourceType)}?`,
    confirmButtonText: "Yes, delete",
  };
}

export function taskStartNowArgs() {
  return {
    header: "Notify & Start Now",
    subHeader: "Confirm you want to start this task now! The assignee will receive a notification.",
    body: "Camino will notify the assignee of this task and the start date will be changed to today.",
    confirmButtonText: "Start now",
  };
}

export function confirmSendNowArgs(
  resourceType: "task" | "email" | "message" | "checkpoint",
  options?: { isRerun?: boolean },
) {
  if (resourceType === "task") {
    return taskStartNowArgs();
  }
  if (resourceType === "checkpoint") {
    const label = options?.isRerun ? "Re-Run Now" : "Run Now";
    return {
      header: label,
      subHeader: "This will run the checkpoint immediately.",
      body: "Are you sure you want to run this checkpoint now? It will check all tasks and send notifications to the configured recipients.",
      confirmButtonText: label,
    };
  }
  return {
    header: `Confirm Send Now`,
    subHeader: "Heads up! This can't be undone.",
    body: `Be sure you want to send this ${titleize(resourceType)} now.`,
    confirmButtonText: "Send now",
  };
}
